<div class="assignments-page">
  <!-- <qai-inner-wrap> -->
  <!-- HEADER -->
  <header *ngIf="!loading" class="page-header">
    <!-- Row 1: Breadcrumbs & Actions -->
    <div class="header-row-one">
      <div class="breadcrumb-container">
        <qai-breadcrumb-list
          [items]="getBreadcrumbItems()"
        ></qai-breadcrumb-list>
      </div>
    </div>

    <!-- Row 2: Tabs -->
    <div class="header-row-two">
      <qai-tabs>
        <ng-template qaiTab="uniqueId1" label="Details">
          <tab-general-details></tab-general-details>
        </ng-template>

        <ng-template qaiTab="uniqueId2" label="Simulations">
          <tab-simulation-details></tab-simulation-details>
        </ng-template>

        <ng-template qaiTab="uniqueId4" label="Assignees">
          <tab-assigness-content></tab-assigness-content>
        </ng-template>
      </qai-tabs>
    </div>
  </header>

  <!-- Loading state -->
  <div *ngIf="loading" class="loading-container">
    <qai-loading [size]="'medium'"></qai-loading>
    <p>Loading assignment details...</p>
  </div>

  <!-- </qai-inner-wrap> -->
</div>
